import React from "react";

const CARD_ITEMS = [
  {
    type: "Blog",
    date: "Jun 09, 2026",
    title:
      "We Already Have an ERP — So Why Is e-Invoicing Still So Difficult to Get Right?",
    href: "https://www.getmogu.co/blog/we-already-have-an-erp-why-is-e-invoicing-still-difficult/",
  },
  {
    type: "Blog",
    date: "Jun 09, 2026",
    title:
      "Do You Really Need to Change Your Invoice Format Just to Become e-Invoicing Compliant?",
    href: "https://www.getmogu.co/blog/do-you-really-need-to-change-your-invoice-format-for-e-invoicing/",
  },
  {
    type: "Blog",
    date: "Jun 09, 2026",
    title:
      "Global e-Invoicing Explained: Key Rules, Challenges, and Trends Businesses Should Know",
    href: "https://www.getmogu.co/blog/global-e-invoicing-explained/",
  },
];

const AuthInsightCards = () => {
  return (
    <section className="auth-insights" aria-label="Latest insights">
      {CARD_ITEMS.map((item) => (
        <a
          className="auth-insight-card"
          key={`${item.type}-${item.date}-${item.title}`}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="auth-insight-orbs" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="auth-insight-content">
            <span className="auth-insight-chip">{item.type}</span>
            <p className="auth-insight-date">{item.date}</p>
            <h3>{item.title}</h3>
          </div>
          <span className="auth-insight-link">Read more</span>
        </a>
      ))}
    </section>
  );
};

export default AuthInsightCards;
